import DataLayer from '../dataLayer';

export default class FavsTracker {

    constructor() {
        this.analytics = window.__pt.fn.analytics;
        this.settings = window.__pt.settings;
        this.events = window.__pt.fn.analytics.events;
        this.pages = window.__pt.fn.analytics.pages;
        this.fn = window.__pt.fn || {}
    }

    async logAddFav(item,origin) {
        const params = {
            event: this.events.trackEvent,
            layer: "hoteles",
            content_type: origin.toString(),
            search_type: item.uri || "",
            element: `${item.id} :: ${item.name}`,
        };
        this.analytics.set(this.events.gtmEvent, {
            eventName: "favs_add",
            ...params,
        });
    }

    async logDeleteFav(item, origin) {
        const params = {
            event: this.events.trackEvent,
            layer: "hoteles",
            content_type: origin.toString(),
            element: `${item.id} :: ${item.name}`,
        };
        this.analytics.set(this.events.gtmEvent, {
            eventName: "favs_delete",
            ...params,
        });
    }

    async logOpenFav(item, origin, count) {
        const fecha_1 = item.checkin ? this.fn.getDate(item.checkin) : "";
        const fecha_2 = item.checkout ? this.fn.getDate(item.checkout) : "";
        let type = "=";
        if (item.totalRoomRatePerNight < item.originalPrice) {
            type = "bajó";
        } else if (item.totalRoomRatePerNight > item.originalPrice) {
            type = "subió";
        }
        const params = {
            event: this.events.trackEvent,
            layer: "hoteles",
            content_type: origin.toString(),
            element: `${item.id} :: ${item.name}`,
            field_date1: fecha_1,
            field_date2: fecha_2,
            extra_info: `${type} :: ${count}`,
        };
        this.analytics.set(this.events.gtmEvent, {
            eventName: "favs_open_item",
            ...params,
        });
    }

    async logOpenFavsList(origin, quantity ) {
        const params = {
            event: this.events.trackEvent,
            layer: "hoteles",
            content_type: origin.toString(),
            element: `${quantity}`,
        };
        this.analytics.set(this.events.gtmEvent, {
            eventName: "favs_open_list",
            ...params,
        });
    }
}
